// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"748":"5d6359d7","910":"863147ca","956":"39fe7f72"}[chunkId] + ".css";
};